import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[showOnScroll]',
})
export class ShowOnScrollDirective {
  @Input() limite = 50;
  private element: HTMLElement;

  constructor(private elementRef: ElementRef) {
    this.element = elementRef.nativeElement;
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrolledPercentage = (scrollTop / (docHeight - windowHeight)) * 100;

    if (scrolledPercentage >= this.limite) {
      this.element.classList.add('show');
    } else {
      this.element.classList.remove('show');
    }
  }
}
